"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchMap = switchMap;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _OuterSubscriber2 = require("../OuterSubscriber");

var _subscribeToResult = require("../util/subscribeToResult");

/* tslint:enable:max-line-length */

/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
  return function switchMapOperatorFunction(source) {
    return source.lift(new SwitchMapOperator(project, resultSelector));
  };
}

var SwitchMapOperator =
/*#__PURE__*/
function () {
  function SwitchMapOperator(project, resultSelector) {
    (0, _classCallCheck2.default)(this, SwitchMapOperator);
    this.project = project;
    this.resultSelector = resultSelector;
  }

  (0, _createClass2.default)(SwitchMapOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    }
  }]);
  return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var SwitchMapSubscriber =
/*#__PURE__*/
function (_OuterSubscriber) {
  (0, _inherits2.default)(SwitchMapSubscriber, _OuterSubscriber);

  function SwitchMapSubscriber(destination, project, resultSelector) {
    var _this;

    (0, _classCallCheck2.default)(this, SwitchMapSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwitchMapSubscriber).call(this, destination));
    _this.project = project;
    _this.resultSelector = resultSelector;
    _this.index = 0;
    return _this;
  }

  (0, _createClass2.default)(SwitchMapSubscriber, [{
    key: "_next",
    value: function _next(value) {
      var result;
      var index = this.index++;

      try {
        result = this.project(value, index);
      } catch (error) {
        this.destination.error(error);
        return;
      }

      this._innerSub(result, value, index);
    }
  }, {
    key: "_innerSub",
    value: function _innerSub(result, value, index) {
      var innerSubscription = this.innerSubscription;

      if (innerSubscription) {
        innerSubscription.unsubscribe();
      }

      this.add(this.innerSubscription = (0, _subscribeToResult.subscribeToResult)(this, result, value, index));
    }
  }, {
    key: "_complete",
    value: function _complete() {
      var innerSubscription = this.innerSubscription;

      if (!innerSubscription || innerSubscription.closed) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(SwitchMapSubscriber.prototype), "_complete", this).call(this);
      }
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe() {
      this.innerSubscription = null;
    }
  }, {
    key: "notifyComplete",
    value: function notifyComplete(innerSub) {
      this.remove(innerSub);
      this.innerSubscription = null;

      if (this.isStopped) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(SwitchMapSubscriber.prototype), "_complete", this).call(this);
      }
    }
  }, {
    key: "notifyNext",
    value: function notifyNext(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
      if (this.resultSelector) {
        this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
      } else {
        this.destination.next(innerValue);
      }
    }
  }, {
    key: "_tryNotifyNext",
    value: function _tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex) {
      var result;

      try {
        result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
      } catch (err) {
        this.destination.error(err);
        return;
      }

      this.destination.next(result);
    }
  }]);
  return SwitchMapSubscriber;
}(_OuterSubscriber2.OuterSubscriber);